module.exports = __webpack_public_path__ + "img/getIcon.230ed051.png";